import { useSortable } from '@dnd-kit/sortable';
import withStyles from 'helpers/withStyles';
import SchedulerBlock from '../SchedulerBlock';

const styles = theme => ({
  dragging: {
    background: theme.palette.grey[800],
    outline: 'none',
    zIndex: 1000000,

    '& > *': {
      opacity: 0,
    },
  },
});

export function SortableSchedulerBlock({ id, classes, disabled, ...props }) {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
  } = useSortable({ id, disabled });

  // Deliberately do NOT apply the `transform`/`transition` from `useSortable`. The Scheduler
  // re-lays-out the entire block list on every drag-over (the live preview IS the drop result),
  // so each block already sits at its correct slot. dnd-kit's sortable strategy would apply its
  // own index-based translation ON TOP of that re-layout, physically shifting rows — most
  // visibly the dragged block's placeholder, which rendered rows away from the slot its time
  // said it would drop into. The list position is the single source of truth; the drag overlay
  // (not a transform) is what follows the pointer.
  return (
    <SchedulerBlock
      ref={setNodeRef}
      className={isDragging ? classes.dragging : undefined}
      data-test-block-dragging={isDragging || undefined}
      {...attributes}
      {...listeners}
      {...props}
    />
  );
}

export default withStyles(styles)(SortableSchedulerBlock);
